module.exports = __webpack_public_path__ + "static/media/Senaryo.ffe807b5.png";